/* Farbvarianten-Chips auf der Produktkachel.
   Ein delegierter Listener auf document - ueberlebt Section-Replacements
   (Filter, Paginierung, Produkt-Empfehlungen) ohne Re-Init. */
(function () {
  if (window.cardColorSwatchesReady) return;
  window.cardColorSwatchesReady = true;

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('.card-swatches__chip');
    if (!chip) return;

    event.preventDefault();
    event.stopPropagation();

    var card = chip.closest('.card-wrapper');
    if (!card) return;

    // Kein data-src = die Variantenbilder zeigen die Farbe nicht (z. B. Christbaum-
    // kugeln: Fotos haengen am Motiv). Dann fuehrt der Klick zur Produktseite mit
    // vorgewaehlter Farbe, statt ein irrefuehrendes Bild einzublenden.
    if (!chip.dataset.src) {
      if (chip.dataset.url) window.location.href = chip.dataset.url;
      return;
    }

    var image = card.querySelector('.card__media img');
    if (image && chip.dataset.src) {
      image.setAttribute('src', chip.dataset.src);
      if (chip.dataset.srcset) image.setAttribute('srcset', chip.dataset.srcset);
      if (typeof chip.dataset.alt === 'string') image.setAttribute('alt', chip.dataset.alt);
    }

    if (chip.dataset.url) {
      card.querySelectorAll('.card__heading a, .card__media a').forEach(function (link) {
        link.setAttribute('href', chip.dataset.url);
      });
    }

    var row = chip.closest('.card-swatches');
    if (row) {
      row.querySelectorAll('.card-swatches__chip').forEach(function (other) {
        other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
      });
    }
  });
})();
